import {Component, OnInit} from '@angular/core';
import {PriceApprovalStatusEnum} from '../../enums/price-approval-status.enum';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';

@Component({
    selector: 'app-price-approval-comment-modal',
    templateUrl: './price-approval-comment-modal.component.html',
    styleUrls: ['./price-approval-comment-modal.component.scss']
})
export class PriceApprovalCommentModalComponent extends ModalDialogV3 implements OnInit {

    public model: { mode: PriceApprovalStatusEnum ,  comment: string };


    constructor() {
        super();
    }

    ngOnInit() {
        this.model = <{ mode: PriceApprovalStatusEnum, comment:string }> { ...this.modalParams.model};
        if ( this.model.mode === PriceApprovalStatusEnum.PRICE_APPROVAL_REQUESTED) {
            // mode only help to display right button title
            console.error('unexpected PriceApprovalCommentModal mode');
            this.close();
        }
    }


    public onCancelBtnClicked() {
        super.close();
    }

    public onDeclineBtnClicked() {
        super.close();
    }


    public onConfirmBtnClicked() {
        this.announceModelChanged(
            {
                msg: 'CONFIRMED',
                comment: this.model.comment
            });
    }

    public getActiveModeTranslation(): string{
        return this.model.mode === PriceApprovalStatusEnum.PRICES_APPROVED ? 'freigeben':'ablehnen'
    }

    public onModalBackgroundClicked() {
    }

    public isCommentRequired() {
        return this.model.mode === PriceApprovalStatusEnum.PRICES_REJECTED
    }
}
